import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Img } from 'react-image';
import { faCheckCircle, faCircle } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, Select } from '@seeqdev/qomponents';

export interface ImageSelectOption {
  text: string;
  value: any;
  imagePath: string;
}

interface ImageSelectProps {
  selectOptions: ImageSelectOption[];
  onChange: (
    option: {
      value: any;
    },
    property?: string,
  ) => void;
  name?: string;
  extraClassNames?: string;
  placeholder?: string;
  value?: any;
  testId?: string;
  insideModal?: boolean;
}

/** Select dropdown element that supports text+image as the individual items */
export const ImageSelect = (props: ImageSelectProps) => {
  const { name, value, selectOptions, extraClassNames, placeholder, onChange } = props;

  const { t } = useTranslation();

  const makeLabel = (option: ImageSelectOption) => {
    const isSelectedValue = value === option.value;
    return (
      <span className="flexColumnContainer tw:items-center">
        <span className="flexColumnContainer tw:w-1/2 tw:items-center">
          <Icon large={true} icon={isSelectedValue ? faCheckCircle : faCircle} type="text" />
          <span className="tw:ml-sq-10">{t(option.text)}</span>
        </span>
        <Img src={option.imagePath} height={25} alt={`${option.text}_image`} className="tw:w-1/2" />
      </span>
    );
  };

  const options = _.map(selectOptions, (option) => ({
    ...option,
    label: makeLabel(option),
  }));

  // This enables a different label to display for the selected item once the menu is closed
  const getOptionLabel = (data: ImageSelectOption) => (
    <span className="flexColumnContainer">
      <span className="tw:mt-0.5 tw:pr-sq-10">{t(data.text)}</span>
      <Img src={data.imagePath} height={20} alt={`${data.text}_image`} />
    </span>
  );

  return (
    <div data-testid={`${name}_image-select`}>
      <Select
        extraClassNames={extraClassNames}
        placeholder={_.isEmpty(placeholder) ? '' : t(placeholder as string)}
        value={_.find(options, { value })}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        options={options}
        isSearchable={false}
        getSelectedValueLabel={getOptionLabel}
        onChange={(selectedOption: { value: unknown }) => onChange(selectedOption, name)}
      />
    </div>
  );
};
